import _ from "lodash";
import ko from "knockout";
import ViewModel from "viewModels/ViewModel";
import AgentSelectorView from "viewModels/policies/editors/AgentSelectorView";
import ServiceResponseValidator from "viewModels/util/ServiceResponseValidator";
import featureToggleService, {
    FeatureToggle,
} from "services/featureToggleService";

const EditCalibrationView = ViewModel.extend(function (calibrationObservable) {
    const self = this;

    self.expertEvaluator = ko.observable();
    self.scoringIndex = ko.observable();
    self.isExpertEvaluation = ko.observable();

    const responseValidator = new ServiceResponseValidator();
    self.evaluators = ko
        .observableArray(calibrationObservable().evaluators())
        .extend({ responseValidator: responseValidator });

    self.evaluatorSelector = self.subView(AgentSelectorView, self.evaluators);

    const isSparkV4FTEnabled = featureToggleService.isEnabled(
        FeatureToggle.WEM_1128_IDUI_SPARK_V4
    );

    /**
     * Sets the expert evaluator based on available evaluators.
     * It helps to maintain the traditional behavior of select dropdown with options binding.
     * @param {Array} evaluators - Optional evaluators array, defaults to current evaluators
     */
    const setDefaultExpertEvaluator = function (evaluators) {
        // Use provided evaluators or get current ones
        evaluators = evaluators || self.evaluators();

        // Safety check for empty evaluators list
        if (!evaluators?.length) return;

        // If no expert evaluator is set, set it directly
        if (!self.expertEvaluator()) {
            self.expertEvaluator(
                ko.unwrap(calibrationObservable()?.expertEvaluator) ||
                    evaluators[0]
            );
            return;
        }

        // Check if current expert evaluator exists in the evaluators list
        const currentEvaluatorId = self.expertEvaluator().id;
        const currentEvaluatorExists = evaluators.some(
            (e) => e.id === currentEvaluatorId
        );

        // If current expert evaluator is not in the list, reset to first evaluator
        if (!currentEvaluatorExists) {
            self.expertEvaluator(evaluators[0]);
        }
    };

    self.subscribe(self.isExpertEvaluation, function (newValue) {
        if (newValue) {
            if (isSparkV4FTEnabled) {
                setDefaultExpertEvaluator();
            } else {
                const expertEvaluator = calibrationObservable().expertEvaluator
                    ? calibrationObservable().expertEvaluator()
                    : undefined;
                self.expertEvaluator(expertEvaluator);
            }
        }
    });

    if (isSparkV4FTEnabled) {
        self.subscribe(self.evaluators, function (newEvaluators) {
            setDefaultExpertEvaluator(newEvaluators);
        });

        self.onChangeExpertEvaluator = function (_data, event) {
            const selectedEvaluatorId = event?.target?.value;

            if (selectedEvaluatorId) {
                const foundEvaluator = _.find(
                    self.evaluators(),
                    (evaluator) => evaluator.id === selectedEvaluatorId
                );
                if (foundEvaluator) {
                    self.expertEvaluator(foundEvaluator);
                }
            }
        };
    }

    self.getResponseValidator = function () {
        return responseValidator;
    };

    self.reset = function () {
        self.isExpertEvaluation(false);
        if (calibrationObservable().expertEvaluator) {
            self.isExpertEvaluation(true);
        }
    };
    self.reset();

    self.getCalibration = function () {
        const calibration = {
            id: calibrationObservable().id,
            agent: {
                id: calibrationObservable().agent().id(),
            },
            conversation: {
                id: calibrationObservable().conversation().id(),
            },
            evaluationForm: {
                id: calibrationObservable().evaluationForm().id,
            },
            evaluators: _.map(self.evaluators(), function (evaluator) {
                return { id: evaluator.id };
            }),
        };

        if (self.isExpertEvaluation() && self.expertEvaluator()) {
            calibration.expertEvaluator = { id: self.expertEvaluator().id };
        }

        return calibration;
    };
});

export default EditCalibrationView;
